import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const filterChip = style(
  {
    backgroundColor: themeVars.color['surface-base'],
    borderRadius: themeVars.radius['2'],
  },
  'condition-filter-chip',
);
